import cloneDeep from 'lodash/cloneDeep';

import type { IViewDataInitialState } from 'src/redux/viewData/types';

const SECTION_KEY = 'ACR_SECTIONS_DETAIL';

interface ReceiveInfographicsAction {
  payload: {
    alignment: unknown;
    widget_id: unknown;
    result: unknown;
  };
}

export const receiveInfographics = (
  state: IViewDataInitialState,
  action: ReceiveInfographicsAction,
): IViewDataInitialState => {
  const newState = cloneDeep(state);
  const { alignment, widget_id, result } = action.payload;
  newState[SECTION_KEY].data.infographics_data = {
    alignment,
    widget_pk: widget_id,
    widget_items: result,
  };
  return newState;
};

export const changeInfographicsEditor = (
  state: IViewDataInitialState,
  action: { value: unknown },
): IViewDataInitialState => {
  const newState = cloneDeep(state);
  newState[SECTION_KEY].data.infographics_editor = action.value;
  return newState;
};
